import React, { useState, useEffect } from 'react'
import { Box, Radio, CheckIcon, Flex, Group, Button } from '@mantine/core'
import { useSelector, useDispatch } from 'react-redux'
import { updateOrder } from '../../../../../services/orders'
import { useParams } from 'react-router-dom'
import { getOrderDetail } from '../../../../../store/orderDetail'
import { notificationSuccess, notificationError, loadingNotification, completedLoadingNotification } from '../../../../ui/Notifications'
import { calculation } from '../../../../../services/calculation'

const defaultVal = {
  show_price_origin: null,
  is_show_landed_only: null,
  is_landed_exclude_vat: null
}

const FormAdjustCustomPayment = ({ onCloseForm }) => {
  const { general } = useSelector(state => state.order_detail)
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const [formData, setFormData] = useState(defaultVal)
  const [loadingForm, setLoadingForm] = useState(false)

  const submitUpdateCustomPayment = async (form) => {
    setLoadingForm(true)
    const payload = {
      show_price_origin: form.show_price_origin === 'enable' ? true : false,
      is_show_landed_only: form.is_show_landed_only === 'enable' ? true : false,
      is_landed_exclude_vat: form.is_landed_exclude_vat === 'enable' ? true : false,
    }
    try {
      const response = await updateOrder(orderId, payload)
      if (response.success) {
        notificationSuccess('Update Order Successfully', 'This data has been updated')
        const loadingCalculation = loadingNotification('Waiting Calculation Order', 'Please Wait. . .')
        const responseCalculation = await calculation(orderId)
        if (responseCalculation.success) {
          onCloseForm()
          dispatch(getOrderDetail(orderId))
          completedLoadingNotification(loadingCalculation, 'Calculation Order Successfully', 'This order has been completed in calculation')
        }
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order Error', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    if (general) {
      handleSetForm(general)
    }
  }, [general])

  const handleSetForm = (value) => {
    const dataDetail = {
      show_price_origin: value.showPriceOrigin ? 'enable' : 'disabled',
      is_show_landed_only: value.showLandedOnly ? 'enable' : 'disabled',
      is_landed_exclude_vat: value.landedExcludeVat ? 'enable' : 'disabled'
    }
    setFormData(dataDetail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  return (
    <Box>
      <Box mb='md'>
        <Radio.Group
          value={formData.show_price_origin}
          onChange={(val) => handleChangeForm('show_price_origin', val)}
          name="show_price_origin"
          label="Show Price Origin"
          withAsterisk
          mb={10}
        >
          <Box mt='xs'>
            <Radio icon={CheckIcon} value="enable" label="Enable" mb={10} />
            <Radio icon={CheckIcon} value="disabled" label="Disabled" />
          </Box>
        </Radio.Group>
      </Box>
      <Box mb='md'>
        <Radio.Group
          value={formData.is_show_landed_only}
          onChange={(val) => handleChangeForm('is_show_landed_only', val)}
          name="is_show_landed_only"
          label="Show Landed Only"
          withAsterisk
          mb={10}
        >
          <Box mt='xs'>
            <Radio icon={CheckIcon} value="enable" label="Enable" mb={10} />
            <Radio icon={CheckIcon} value="disabled" label="Disabled" />
          </Box>
        </Radio.Group>
      </Box>
      <Box mb='md'>
        <Radio.Group
          value={formData.is_landed_exclude_vat}
          onChange={(val) => handleChangeForm('is_landed_exclude_vat', val)}
          name="is_landed_exclude_vat"
          label="Landed Exclude VAT"
          withAsterisk
          mb={10}
        >
          <Box mt='xs'>
            <Radio icon={CheckIcon} value="enable" label="Enable" mb={10} />
            <Radio icon={CheckIcon} value="disabled" label="Disabled" />
          </Box>
        </Radio.Group>
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitUpdateCustomPayment(formData)}>{general ? 'Update' : 'Create'}</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustCustomPayment